import Route from '@ember/routing/route';

export default class ScreensPixelsPixelRoute extends Route {
  model(): void {
    return;
  }
}
